import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const Pager = ({ page, pageCount, itemCount, totalLimit, onPageChanged, onPageSizeChanged }) => {
  const pageDescription = useMemo(() => {
    const minRowNumber = itemCount !== 0 ? (page.index * page.size) + 1 : 0;
    const lastRow = (page.index * page.size) + page.length;
    const maxRowNumber = (lastRow > itemCount) ? itemCount : lastRow;
    const totalRowNumber = `${ itemCount }${ itemCount === totalLimit ? '+' : '' }`;
    return (<span id="eSummaryPanel" className="ag-paging-row-summary-panel">
      <span id="lbFirstRowOnPage"> { minRowNumber}</span> to <span id="lbLastRowOnPage">{ maxRowNumber} </span>of <span id="lbRecordCount">{ totalRowNumber }</span>
    </span>);
  }, [page.index, page.size, page.length, pageCount, itemCount, totalLimit]);

  const pages = useMemo(() => {
    let pagesArray = Array.from({ length: pageCount }, (_, i) => ({ page: i + 1, index: i, show: false, extend: false })).map((p) => {
      if (p.index === 0 || p.index === pageCount - 1) {
        p.show = true;
      } else if (page.index < 5 && p.index < 5) {
        p.show = true;
      } else if (page.index > (pageCount - 6) && p.index > (pageCount - 6)) {
        p.show = true;
      } else if (p.index >= (page.index - 2) && p.index <= (page.index + 2)) {
        p.show = true;
      }
      return p;
    });
    pagesArray = pagesArray.map((p,) => {
      if (p.index > 0) {
        const previousPageindex = p.index - 1;
        const nextPageindex = p.index + 1;
        if (pagesArray) {
          if (!p.show && pagesArray[previousPageindex].show && previousPageindex !== 0) {
            p.extend = true;
          } else if (!p.show && pagesArray[nextPageindex].show && nextPageindex !== (pageCount - 1)) {
            p.extend = true;
          }
        }
      }
      return p;
    });
    return pagesArray;
  }, [page.index, page.size, pageCount, itemCount]);

  return (<div className="ag-paging-panel ag-font-style">
    {pageDescription }
    <span className="ag-paging-page-summary-panel">
      <button type="button" className="btn ag-paging-button" id="btFirst" disabled={ !page.canPreviousPage } onClick={ () => onPageChanged(0) }>First</button>
      <button type="button" className="btn ag-paging-button" id="btPrevious" disabled={ !page.canPreviousPage } onClick={ () => onPageChanged(page.index - 1) }>Previous</button>
      { pages.map((p) => {
        if (p.show) {
          return <button key={ p.page } type="button" className={ `btn ag-paging-button ${ p.index === page.index ? 'active' : '' }` } id={ `btPage${ p.index }` } onClick={ () => onPageChanged(p.index) }>{ p.page }</button>;
        }
        if (p.extend) {
          return <button key={ p.page } type="button" className="btn ag-paging-button extend" id={ `btPage${ p.index }` } onClick={ () => onPageChanged(p.index) }>...</button>;
        }
        return null;
      }) }
      <button type="button" className="btn ag-paging-button" id="btNext" disabled={ !page.canNextPage } onClick={ () => onPageChanged(page.index + 1) }>Next</button>
      <button type="button" className="btn ag-paging-button" id="btLast" disabled={ !page.canNextPage } onClick={ () => onPageChanged(pageCount - 1) }>Last</button>
    </span>
    <span id="ePageSize" className="ag-page-size">
      <select id="pageSize" className="form-select" value={ page.size } onChange={ (e) => { onPageSizeChanged(Number(e.target.value)); } }>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </span>
  </div>);
};

Pager.propTypes = {
  page: PropTypes.shape({
    index: PropTypes.number,
    size: PropTypes.number,
    length: PropTypes.number,
    canPreviousPage: PropTypes.bool,
    canNextPage: PropTypes.bool,
  }).isRequired,
  pageCount: PropTypes.number.isRequired,
  itemCount: PropTypes.number.isRequired,
  totalLimit: PropTypes.number.isRequired,
  onPageChanged: PropTypes.func.isRequired,
  onPageSizeChanged: PropTypes.func.isRequired
};

export default Pager;
